// extracted by mini-css-extract-plugin
export var activeFilterButton = "_mr-c";
export var backButton = "_mr-4";
export var backIcon = "_mr-5";
export var chevronShortcut = "_mr-6";
export var container = "_mr-1";
export var editor = "_mr-8";
export var editorWrapper = "_mr-7";
export var prefix = "_mr-2";
export var searchIcon = "_mr-3";
export var suffix = "_mr-9";
export var suffixContent = "_mr-a";
export var suffixText = "_mr-b";
export var wrapper = "_mr-0";